import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoginService } from '@app/pages/login/services/login.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { CommonService } from '@app/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { UI_LINKS } from '@app/shared/data/values';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  isLoading$ = new Observable<boolean>();
  hasFullAccess: boolean;
  hasFormChanges: boolean = false;
  hasFormChangesSubs$: Subscription;
  appLinks = UI_LINKS;
  private readonly unsubscribeAll$ = new Subject();
  profileName!: string;

  constructor(
    private readonly loginService: LoginService,
    private readonly _commonS: CommonService,
    private readonly _router: Router,
  ) {
    this.hasFullAccess = this._commonS.hasFullAccess;
    const userProfile = this._commonS.appProfileDataAsValue.user.profile;
    this.profileName = userProfile.firstName;
    this.hasFormChangesSubs$ = this._commonS.hasFormChanges
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe(data => this.hasFormChanges = data);
  }

  ngOnInit(): void {
    this.isLoading$ = this._commonS.isLoading;
  }

  ngOnDestroy(): void {
    this.hasFormChangesSubs$.unsubscribe();
    this.unsubscribeAll$.next(null);
    this.unsubscribeAll$.complete();
  }

  get showNotifications(): boolean {
    return environment.enableNotifications
      && !!this._commonS.appProfileDataAsValue
        ?.currentOrganization
        ?.enterprise_referral_enabled;
  }

  logOut() {
    if (this.hasFormChanges) {
      this._router.navigate(['auth/signin'], { queryParams: { returnTo: this._router.url } });
      return;
    }
    this.loginService.logout();
  }
}
